<template>
    <div>
        <div class="emp-tree-row" :style="{ paddingLeft: (level * 24 + 14) + 'px' }">
            <div class="emp-tree-name">
                <i v-if="hasChildren" class="far fa-chevron-right emp-tree-toggle" :class="{ expanded: isOpen }" @click="toggle"></i>
                <i v-else class="far fa-circle emp-tree-dot"></i>
                <a :href="'/stocks/emplacements/' + node.id" class="emp-tree-link">
                    <i class="far fa-map-marker-alt text-primary mr-1"></i>{{ node.name }}
                </a>
                <span v-if="node.code" class="emp-tree-code">{{ node.code }}</span>
            </div>
            <div class="emp-tree-qty">
                <span class="font-weight-bold text-dark">{{ formatQty(node.quantity) }}</span>
                <span class="emp-tree-unit">{{ unit }}</span>
            </div>
        </div>
        <div v-if="hasChildren && isOpen">
            <emp-tree-node
                v-for="child in node.children"
                :key="child.id"
                :node="child"
                :unit="unit"
                :level="level + 1">
            </emp-tree-node>
        </div>
    </div>
</template>

<script>
export default {
    name: 'emp-tree-node',
    props: {
        node: { type: Object, required: true },
        unit: { type: String, default: 'unité(s)' },
        level: { type: Number, default: 0 }
    },
    data() {
        return {
            isOpen: true
        };
    },
    computed: {
        hasChildren() {
            return this.node.children && this.node.children.length > 0;
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
        formatQty(q) {
            if (q === null || q === undefined) return 0;
            return parseFloat(q);
        }
    }
};
</script>

<style scoped>
.emp-tree-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.12s ease;
}

.emp-tree-row:hover {
    background-color: #f8fafc;
}

.emp-tree-name {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13.5px;
}

.emp-tree-toggle {
    cursor: pointer;
    font-size: 12px;
    color: #94a3b8;
    transition: transform 0.2s ease;
    width: 14px;
}

.emp-tree-toggle.expanded {
    transform: rotate(90deg);
}

.emp-tree-dot {
    font-size: 5px;
    color: #cbd5e1;
    width: 14px;
}

.emp-tree-link {
    color: #1e293b;
    font-weight: 600;
    text-decoration: none;
}

.emp-tree-link:hover {
    color: #3b82f6;
}

.emp-tree-code {
    font-size: 10px;
    color: #64748b;
    background: #f1f5f9;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    margin-left: 4px;
}

.emp-tree-qty {
    display: flex;
    align-items: baseline;
    gap: 4px;
    font-size: 14px;
}

.emp-tree-unit {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 400;
}
</style>
